const en = {
  nav: {
    aiSupportDemo: "AI Support Assistant",
    howItWorks: "How It Works",
    industries: "Industries",
    startFreeDemo: "Start Free Demo",
  },
  landing: {
    heroTitle: "Transform Your Customer Support with AI",
    heroSubtitle:
      "See how AI can handle your customer inquiries in minutes. Upload your docs or try a pre-built demo — no signup needed.",
    startFreeDemo: "Start Free Demo",
    learnMore: "Learn More",
    benefits: {
      noSignup: "No signup required",
      freeTry: "Free to try",
      dataSecure: "Your data is secure",
      twoMinutes: "Takes less than 2 minutes",
    },
    howItWorksTitle: "How It Works",
    howItWorksSubtitle:
      "Get started in three simple steps. No technical knowledge required.",
    features: {
      uploadTitle: "Upload Your Docs",
      uploadDesc:
        "Simply upload your FAQ, product docs, or knowledge base files. We support PDF, Word, Markdown, and text files.",
      aiLearnsTitle: "AI Learns Instantly",
      aiLearnsDesc:
        "Our AI processes your documents in seconds, creating a personalized customer service agent tailored to your business.",
      startChattingTitle: "Start Chatting",
      startChattingDesc:
        "Test the AI with real customer questions. See how it uses your documentation to provide accurate, helpful responses.",
    },
    industryTemplatesTitle: "Industry Templates",
    industryTemplatesSubtitle:
      "Don't have documents ready? Try our pre-built industry demos.",
    industries: {
      ecommerce: "E-commerce",
      ecommerceDesc: "Product support, orders, returns",
      saas: "SaaS",
      saasDesc: "Feature guides, billing, tech help",
      healthcare: "Healthcare",
      healthcareDesc: "Appointments, insurance, info",
      financial: "Financial",
      financialDesc: "Account info, loans, inquiries",
      education: "Education",
      educationDesc: "Courses, admissions, services",
    },
    trust: {
      secureTitle: "Secure & Private",
      secureDesc:
        "Your documents are processed securely and never stored permanently.",
      instantTitle: "Instant Setup",
      instantDesc: "Go from upload to chatting in under 60 seconds.",
      gptTitle: "Powered by DeepSeek · Qwen",
      gptDesc: "Enterprise-grade AI powered by DeepSeek and Qwen for accurate, helpful responses.",
    },
    stats: {
      concurrentNum: "1000+",
      concurrentLabel: "Concurrent Sessions",
      resolutionNum: "98%",
      resolutionLabel: "Resolution Rate",
      responseNum: "3s",
      responseLabel: "Avg Response Time",
      availabilityNum: "24/7",
      availabilityLabel: "Always Available",
    },
    features6Tag: "Core Features",
    features6Title: "Why Choose AI Support Assistant?",
    features6Subtitle: "Built on large language model technology, deeply integrated with enterprise workflows for truly intelligent customer service.",
    features6: {
      f1Title: "Concurrent at Scale",
      f1Desc: "Handle 1000+ simultaneous customer inquiries with zero wait time, dramatically improving satisfaction.",
      f2Title: "LLM-Powered",
      f2Desc: "Advanced AI understands complex, nuanced questions and gives precise answers — no template-based replies.",
      f3Title: "Knowledge Base",
      f3Desc: "AI deeply learns your documents, building a vector knowledge base for accurate, brand-consistent answers.",
      f4Title: "Semantic Understanding",
      f4Desc: "Understands real customer intent, not just keywords. Supports multi-turn dialogue and contextual follow-up.",
      f5Title: "WeChat Work Integration",
      f5Desc: "Seamlessly integrates with WeChat Work. One-click activation within your existing customer service setup.",
      f6Title: "Analytics & Insights",
      f6Desc: "Real-time service quality monitoring and customer inquiry trend analysis to continuously improve your strategy.",
    },
    testimonialsTag: "Customer Stories",
    testimonialsTitle: "Trusted by Industry Leaders",
    testimonialsSubtitle: "See how businesses are transforming customer service with AI Support Assistant.",
    testimonials: {
      t1Text: "After integrating AI Support, our team efficiency improved by 300%. What used to require 10 people can now be handled by 3, with higher customer satisfaction.",
      t1Author: "Manager Zhang",
      t1Role: "Customer Service Director, E-commerce Platform",
      t2Text: "What impressed me most was the AI's understanding of our knowledge base. After uploading hundreds of pages of product manuals, it not only answers accurately but proactively recommends related products.",
      t2Author: "CEO Li",
      t2Role: "Founder, SaaS Company",
      t3Text: "24/7 service solved our biggest challenge. Overseas customers no longer wait for business hours — professional replies anytime, greatly improving customer experience.",
      t3Author: "Supervisor Wang",
      t3Role: "Operations Manager, Cross-border E-commerce",
    },
    ctaTitle: "Ready to Transform Your Customer Support?",
    ctaSubtitle:
      "Join thousands of businesses using AI to deliver faster, more accurate customer service.",
    ctaButton: "Start Your Free Demo",
    footer: "InfiniteOpen Technology · All rights reserved.",
  },
  demoSelector: {
    title: "How would you like to try the demo?",
    subtitle:
      "Choose the option that works best for you. Both are free and take less than 2 minutes.",
    upload: {
      title: "Upload Your Documents",
      description:
        "Upload your FAQ, product docs, or knowledge base files and see how AI handles your specific support scenarios.",
      action: "Select Files",
      features: {
        formats: "PDF, Word, Markdown support",
        multiple: "Multiple files",
        relevant: "Most relevant experience",
      },
    },
    template: {
      title: "Try Template Demo",
      description:
        "Choose from our pre-built industry scenarios. No documents needed — start chatting immediately.",
      action: "Browse Templates",
      features: {
        templates: "5 industry templates",
        instant: "Instant start",
        realistic: "Realistic scenarios",
      },
    },
    recommended: "Recommended",
    tip: "Tip: Upload your own documents for the most relevant experience tailored to your business.",
  },
  upload: {
    title: "Upload Documents",
    back: "Back",
    pageTitle: "Upload Your Knowledge Base",
    pageSubtitle:
      "Upload your FAQ, product documentation, or any support materials. Our AI will learn from them instantly.",
    dropZoneTitle: "Drop files here or click to browse",
    dropZoneSubtitle: "Supports PDF, DOCX, MD, TXT (max {{size}} each)",
    filesCount: "Files ({{count}}/{{max}})",
    clearAll: "Clear all",
    uploading: "Uploading...",
    processing: "Processing...",
    filesReady: "{{count}} of {{total}} files ready",
    cancel: "Cancel",
    uploadAndContinue: "Upload & Continue",
    errors: {
      noValidFile: "Please add at least one valid file to upload.",
      tooManyFiles: "You can only upload up to {{max}} files.",
      fileTooLarge: "File size exceeds {{size}}",
      invalidType:
        "Invalid file type. Only PDF, DOCX, MD, and TXT files are allowed.",
    },
  },
  rateLimit: {
    title: "Demo limit reached",
    message: "You've used the maximum demo sessions for this hour. Interested in getting this for your business?",
    contactUs: "Contact Us",
    tryLater: "Try again later",
  },
  templateGallery: {
    headerTitle: "Choose a Template",
    title: "Choose an Industry Demo",
    subtitle:
      "Select a pre-built scenario to see how AI customer service works for your industry.",
    loading: "Loading templates...",
    tryAgain: "Try Again",
    tryAsking: "Try asking:",
    tryDemo: "Try Demo",
    back: "Back",
    tipText:
      "Want a more personalized experience? Upload your own documents to see how AI handles your specific content.",
    uploadDocsLink: "Upload Your Own Docs",
  },
  chat: {
    back: "Back",
    aiSupportDemo: "AI Support Assistant",
    customKnowledge: "Custom Knowledge",
    templateDemo: "Template Demo",
    getThisForBusiness: "Get This for Your Business",
    typeMessage: "Type your message...",
    send: "Send",
    disclaimer:
      "This is a demo environment. Responses are generated based on uploaded documents or template content.",
    source: "Source: {{document}}",
    welcomeUpload:
      "Welcome! I'm your AI support assistant. I've learned from the documents you uploaded and I'm ready to answer questions based on that information. What would you like to know?",
    welcomeTemplate:
      "Welcome! I'm your AI support assistant for {{industry}}. I've been trained on industry-specific documentation and I'm ready to help with your questions. What would you like to know?",
  },
  suggestedQuestions: {
    ecommerce: {
      q1: "What's your return policy?",
      q2: "How do I track my order?",
      q3: "How long does shipping take?",
      q4: "Can I cancel or modify my order?",
    },
    saas: {
      q1: "How do I reset my password?",
      q2: "What features are included in the Pro plan?",
      q3: "How do I cancel my subscription?",
      q4: "Is there a free trial available?",
    },
    healthcare: {
      q1: "How do I book an appointment?",
      q2: "What insurance plans do you accept?",
      q3: "How do I access my medical records?",
      q4: "What are your clinic hours?",
    },
    financial: {
      q1: "How do I open a new account?",
      q2: "What are your current loan rates?",
      q3: "How do I report a lost or stolen card?",
      q4: "What are the fees for wire transfers?",
    },
    education: {
      q1: "What courses do you offer?",
      q2: "How do I apply for admission?",
      q3: "What financial aid options are available?",
      q4: "How do I access student services?",
    },
    upload: {
      q1: "What services do you offer?",
      q2: "How do I get started?",
      q3: "What are your business hours?",
      q4: "How do I contact support?",
    },
  },
  leadCapture: {
    title: "Ready to Transform Your Customer Support?",
    description:
      "You've spent {{duration}} exploring the demo and asked {{count}} question(s). Let's discuss how this can work for your specific needs.",
    thankYouTitle: "Thank You!",
    thankYouDesc:
      "We've received your information and will be in touch shortly. Feel free to continue exploring the demo!",
    continueDemo: "Continue Demo",
    getMoreInfo: "Get More Information",
    bookCall: "Book a Call",
    submitting: "Submitting...",
    fields: {
      name: "Name",
      email: "Work Email",
      company: "Company",
      phone: "Phone",
      message: "What interests you most?",
      optional: "(optional)",
      consent:
        "I agree to the Privacy Policy and allow contact regarding AI customer service solutions.",
    },
    placeholders: {
      name: "John Doe",
      email: "john@company.com",
      company: "Acme Inc.",
      phone: "+1 (555) 123-4567",
      message: "Tell us about your use case or any questions you have...",
    },
    errors: {
      nameRequired: "Name is required",
      emailRequired: "Email is required",
      emailInvalid: "Please enter a valid email",
      companyRequired: "Company is required",
      consentRequired: "You must agree to the privacy policy",
    },
    continueDemoArrow: "Continue Demo →",
  },
}

export default en
